export class TaskCompletion {

  taskId: number;
  documentIds: number[] = [];
  transportId: number;
  resourceIds: string[];

}
